import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BreakPointToken } from '@vaad1st/hook.media-query';
import tokens from '@vaad1st/shared.design-tokens/json/variables.json';

const dot = css`
	content: '';
	display: inline-block;
	width: ${tokens.spacing_4px.value}px;
	height: ${tokens.spacing_4px.value}px;
	border-radius: 100%;
	background-color: var(--color-background-neutral-tertiary);
`;

export const SummaryPlayback = styled.div`
	width: 100%;
	text-align: left;
	margin-left: 20px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	overflow: hidden;
	margin-right: ${tokens.spacing_12px.value}px;

	.summary-title {
		@media (max-width: ${BreakPointToken.SmMax}px) {
			flex: 0 0 100%;
			white-space: nowrap;
			width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		&::after {
			@media (min-width: ${BreakPointToken.MdMin}px) {
				${dot}
				margin: ${tokens.spacing_2px.value}px ${tokens.spacing_8px.value}px;
			}
		}
	}

	p {
		white-space: nowrap;
		width: max-content;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	span + span {
		&::before {
			${dot}
			margin: ${tokens.spacing_2px.value}px ${tokens.spacing_8px.value}px;
		}
	}
`;
